import { Directive } from '@angular/core';

@Directive({
  selector: '[appFormControlInputSuffix]',
  standalone: true,
})
export class FormControlInputSuffixDirective {}
